import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-expand-right",
  "use": "svg_arrow-expand-right-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"svg_arrow-expand-right\"><path d=\"m1 1 5 5-5 5\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol